import React from 'react'
import palette from 'core-system/Themes/palette'
import SummaryBudget from './components/SummaryBudget'
import SummaryOptions from './components/SummaryOptions'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import CreditCard from 'core-system/Icons/Accounts/CreditCard'
import wordings from '../Shared/wordings.json'
import { transitPassType } from '../Shared/types'

interface TransitPassSummaryProps {
  transitPass: transitPassType
}

const TransitPassSummary = ({ transitPass }: TransitPassSummaryProps) => {
  const purchaseTypeKey =
    transitPass.purchaseType === 'FIXED'
      ? 'fixedPassPurchase'
      : 'employeeChoicePass'
  const deliveryKey =
    transitPass.passDeliveryMechanism === 'VIRTUAL'
      ? 'virtualPassDelivery'
      : 'physicalPassDelivery'

  return (
    <SummaryContainerBox title={wordings.transitPass.title}>
      <SummaryOptions
        icon={<CreditCard color={palette.secondary.purple600} />}
        activeOptions={[
          {
            type: purchaseTypeKey,
            activeMerchantIds: [],
            active: true,
          },
          {
            type: deliveryKey,
            activeMerchantIds: [],
            active: true,
          },
          {
            type: 'transitAgencies',
            activeMerchantIds: transitPass.agenciesEnabled
              ? transitPass.transitAgencyIds
              : [],
            active:
              transitPass.agenciesEnabled &&
              transitPass.transitAgencyIds.length > 0,
          },
        ]}
      />
      {transitPass.walletTopUpEnabled && (
        <SummaryBudget
          title='Wallet Top-Up'
          lines={[
            {
              title: 'Employer Contribution',
              value: transitPass.budget,
            },
          ]}
        />
      )}
    </SummaryContainerBox>
  )
}

export default React.memo(TransitPassSummary)
